<template>
    <svg :class="className" width="18" height="15" viewBox="0 0 18 15">
        <path d="M13.5714 3.94454C13.1438 4.92795 12.1636 5.61561 11.0229 5.61561C9.88209 5.61561 8.90193 4.92795
            8.4743 3.94454H1.222C0.608355 3.94454 0.110893 3.44708 0.110893 2.83343C0.110893 2.21978 0.608355 1.72232
            1.222 1.72232H8.47815C8.9078 0.743615 9.8855 0.0600586 11.0229 0.0600586C12.1602 0.0600586 13.1379 0.743615
            13.5676 1.72232H16.7776C17.3912 1.72232 17.8887 2.21978 17.8887 2.83343C17.8887 3.44708 17.3912 3.94454
            6.7776 3.94454H13.5714ZM4.48263 12.8334C4.91026 13.8168 5.89042 14.5045 7.03119 14.5045C8.17196 14.5045
            9.15212 13.8168 9.57976 12.8334H16.7776C17.3912 12.8334 17.8887 12.336 17.8887 11.7223C17.8887 11.1087
            17.3912 10.6112 16.7776 10.6112H9.57591C9.14626 9.6325 8.16855 8.94895 7.03119 8.94895C5.89383 8.94895
            4.91613 9.6325 4.48648 10.6112H1.222C0.608355 10.6112 0.110893 11.1087 0.110893 11.7223C0.110893 12.336
            0.608355 12.8334 1.222 12.8334H4.48263Z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
